import { Box } from "@kaltura/mediaspace-shared-styled";
import { GenieProps } from "./Genie";
import { useSidebarLayoutContext } from "@kaltura/ds-react-layouts";
import { Genie } from "./Genie";
import { styled } from "@mui/material";
import { useEffect, useRef, useState } from "react";

export interface GenieSidePanelProps
    extends Omit<GenieProps, "isFullSize" | "visualType" | "onExpand" | "onClose" | "isExpanded"> {
    onToggleExpand?: (isExpanded: boolean) => void;
}

const StyledWrapper = styled(
    Box,
    {
        shouldForwardProp: (prop) => prop !== "isExpanded",
    }
)<{ isExpanded: boolean }>(({ theme, isExpanded }) =>
    isExpanded
        ? {
              position: "fixed",
              inset: 0,
              zIndex: theme.zIndex.modal + 1,
              backgroundColor: theme.palette.background.paper,
              display: "flex",
              flexDirection: "column",
          }
        : {
              display: "flex",
              flexDirection: "column",
              height: "100%",
          }
);

const StyledContent = styled(Box)({
    flex: 1,
    overflow: "hidden",
});

/*
 * Genie side panel
 * renders Genie widget in a styled side panel
 */
export const GenieSidePanel = ({ onToggleExpand, ...genieProps }: GenieSidePanelProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { isOpened, setIsOpened } = useSidebarLayoutContext();
    const panelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isOpened) {
            panelRef.current?.focus();
        }
    }, [isOpened]);

    const toggleExpanded = () => {
        setIsExpanded((prev) => {
            const next = !prev;
            onToggleExpand?.(next);
            return next;
        });
    };

    const handleClose = () => {
        setIsExpanded(false);
        setIsOpened(false);
    };

    return (
        <StyledWrapper ref={panelRef} tabIndex={-1} isExpanded={isExpanded} data-testId={"genie-side-panel"}>
            <StyledContent>
                <Genie
                    {...genieProps}
                    isFullSize={true}
                    visualType="contained"
                    onExpand={toggleExpanded}
                    onClose={handleClose}
                    isExpanded={isExpanded}
                />
            </StyledContent>
        </StyledWrapper>
    );
};
